import React from 'react'
import ModalWrapper from '../../common/Modal/ModalWrapper'
import { toggleModal } from '../../../reducers/modalReducer'
import { useDispatch } from 'react-redux';

const HowItWorkModal = ({ selectedHowItWorks }) => {
    const dispatch = useDispatch();
    return (
        <>
            <ModalWrapper id="keyFeatureSeeMore" modalType={'howItWorksPopupNew'} modalCardClasses='maw1300px' >
                <div className='df fww w100'>
                    {selectedHowItWorks?.['isStoryVideo'] &&
                        <div className='df jcc fdc pa' style={{ right: '-7%', top: '-5%' }}>
                            <img src={require('../../../../images/landingpage/Cybersecurity_Mask.png')} className="w70" style={{ borderRadius: '50%' }} />
                            <img src={require('../../../../images/videoButton.png')} onClick={() => dispatch(toggleModal({ open: "videoCompanies" }))} className='cp zi1' />
                        </div>
                    }
                    <h2 className='w100 tac c15 fs1-75rem fw500'>How does it work?</h2>
                    {selectedHowItWorks?.['subTitle'] && <h6 className='w100 tac c15 fs1-25rem fw500 mb1rem'>{selectedHowItWorks?.['subTitle']}</h6>}
                    <div className='step-top-box df w100 jcc'>
                        <img src={selectedHowItWorks?.['stepImage']} className="w70" style={{ objectFit: 'fill' }} />
                    </div>
                    <div className='step-box-images df jcsb mt1rem mb2rem mla mra'>
                        {selectedHowItWorks?.['arrayImages'].length}
                        {(selectedHowItWorks?.['arrayImages'] && selectedHowItWorks?.['arrayImages'].length > 0) && <>{
                            selectedHowItWorks?.['arrayImages'].map(image => {
                                return (
                                    <div className='step-img df jcc px1rem'>
                                        <img className='' src={image} alt="ste image" />
                                    </div>
                                )
                            })
                        }</>}
                    </div>
                    {selectedHowItWorks?.['checkList'] &&
                        <div className='checklist-area aic df bg1 py0-5rem w90 mla mra br45px mb1rem jcsb bsbb'>
                            {(selectedHowItWorks?.['checkList'] && selectedHowItWorks?.['checkList'].length > 0) && <>{
                                selectedHowItWorks?.['checkList'].map(array => {
                                    return (
                                        <div className='checklist-inner w100 pr'>{array}</div>
                                    )
                                })
                            }</>}
                        </div>
                    }
                    <div className='df jcc w100'>
                        {selectedHowItWorks?.['bottomSection'] && <p className='fs1-25rem c12 mb1rem tac w100'>{selectedHowItWorks?.['bottomSection']}</p>}
                    </div>
                    <div className='df jcc w100'>
                        <button>{selectedHowItWorks?.['btnContent']}</button>
                    </div>
                </div>
            </ModalWrapper>

        </>
    )
}

export default HowItWorkModal